"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var UserBackSignUp = function (_a) {
    var _b;
    var backToForm = _a.backToForm;
    var t = (0, next_intl_1.useTranslations)('translation');
    var first = (0, swr_hooks_1.useCalculateWelcomePackage)().first;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('userBackSignUpTitle')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusTitle }, (_b = first === null || first === void 0 ? void 0 : first.descriptions) === null || _b === void 0 ? void 0 : _b.shortTitle)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('userBackSignUpDescription')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: backToForm }, t('joinNow')))));
};
exports.default = UserBackSignUp;
